import SystemFieldProto from '../../proto/system-field-proto';
import mapTag from "../../import/normalize/map-tag";
import SystemFieldTagsViewInImport from "./components/view-in-import";


export default class TagsField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.TAGS;
    }

    get sortHintMessage() {
        return 'Sort by tags';
    }

    getCsvValue(item) {
        const getTagName = (tagId) => {
            const tag = gd.session.projects.get(tagId);
            return tag ? tag.name : '';
        }

        return _.map(item.tags, id=>getTagName(id)).join(', ');
    }

    listItemSortFunctions(sort) {
        const tagNames = (tags)=>{
            const tagsNames = [];
            tags && tags.map(tId=>{
                const tag = gd.session.projects.get(tId);
                if (tag && !tag.isArchived) tagsNames.push(tag.name);
            });
            return _.orderBy(tagsNames,[name=>name],['asc']).join(',');
        };

        return {
            functions: [i => i.type === 'task' && i.item.tags ? i.item.tags.length : 0, i => i.type === 'task' ? tagNames(i.item.tags) : ''],
            directions: [sort,sort]
        }
    }

    // IMPORT

    normalizeCSVValue(value, csvImporter) {

        if (!value) return;

        let errors = false;

        let tagNames = value.split(csvImporter.multiValueDelimiter);
        tagNames = _.map(tagNames, tagName=>tagName.trim())

        const tags = [];
        _.map(tagNames,tagName=>{
            const tagId = mapTag(tagName);
            if (tagId) {
                tags.push(tagId);
            } else {
                tags.push(tagName)
                errors = true;
            }
        })

        if (errors) return

        return tags;
    }

    getComponentViewInImport() {
        return SystemFieldTagsViewInImport;
    }

}
